// GLOBAL THEME JS

// DOM SELECTION 

// Search Bar Wrapper 
const searchWrapper = document.querySelector('.header-search-bar--wrapper');
const searchInner = document.querySelector('.search-inner');

//Functions Site Wide

// Header Mobile

const mobNavAcc = document.getElementsByClassName("accordion-mobile");

for (i = 0; i < mobNavAcc.length; i++) {
  mobNavAcc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}

function closeAll(){
	 for (i = 0; i < mobNavAcc.length; i++) {
    	mobNavAcc[i].classList.remove("active");
        mobNavAcc[i].nextElementSibling.style.maxHeight = null;
    }
}
// mobNavAcc[0].click();



// Search Function
var predictiveSearchInput = document.getElementById('searchInputField');
var timer;

var offcanvasSearch = document.getElementById('searchResult');
var bsOffcanvas = document.getElementById('searchResult');

if(predictiveSearchInput != null) {
    predictiveSearchInput.addEventListener('input', function(e) {

        clearTimeout(timer);

        if(predictiveSearchInput.value) {
            timer = setTimeout(fetchPredictiveSearch, 500);
        }
        
    });
}

function fetchPredictiveSearch() {
    fetch(`/search/suggest.json?q=${predictiveSearchInput.value}&resources[type]=product`)
    .then(resp => resp.json())
    .then(data => { 
        console.log(data);

        var products = data.resources.results.products;

        document.getElementById('search_results_body').innerHTML = '';

        products.forEach(function(product, index) {
            document.getElementById('search_results_body').innerHTML += `
                <a href="${product.url}">
                    <div class="flex items-start mb-10" style="w-320">
                    <img src="${product.image}" class="w-100">
                    <div class="ml-10">
                        <p class="uppercase mt-0 mb-5">${product.title}</p>
                        <p class="m-0" style="color:#edd100;">$${product.price}</p>
                    </div>
                </div>
                </a>
            `
        });
        bsOffcanvas.classList.add("block");
    });
}

function openSearch() {
  searchWrapper.classList.toggle("shown");
  searchInner.classList.toggle("shown-2");
}

function removeSearch() {
  searchWrapper.classList.remove("shown");
  searchInner.classList.remove("shown-2");
}



// Currency Change
function currencyFormSubmit(event) {
  event.target.form.submit();
}

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });


  // Mobile Nav 

  document.querySelector("#toggle").addEventListener("click", function() {
    this.classList.toggle("active");
    document.querySelector("#overlay").classList.toggle("open");
    document.querySelector("body").classList.toggle("active_overlay");
  })

// Tabs

// Define variables
var tabLabels = document.querySelectorAll("#tabs li");
var tabPanes = document.getElementsByClassName("tab-contents");

function activateTab(e) {
  e.preventDefault();
  
  // Deactivate all tabs
  tabLabels.forEach(function(label, index){
    label.classList.remove("active");
  });
  [].forEach.call(tabPanes, function(pane, index){
    pane.classList.remove("active");
  });
  
  // Activate current tab
  e.target.parentNode.classList.add("active");
  var clickedTab = e.target.getAttribute("href");
  document.querySelector(clickedTab).classList.add("active");
}

  // Apply event listeners
  tabLabels.forEach(function(label, index){
    label.addEventListener("click", activateTab);
  });


  // QUick Add COllection 

  // document.querySelectorAll('.quick-add-wrapper').forEach(div => {
  //   div.onclick = show;
  // });
  
  // function show() {
  //   const hidden = this.getElementsByClassName('quick-add-popup')[0];
  //   if (hidden.style.display == 'none') {
  //     hidden.style.display = 'block';
  //   } else {
  //     hidden.style.display = 'none';
  //   }
  // }



  if (document.body.classList.contains('body-template--index')) {
  const targetElement = document.querySelector('.header_section_fix'); 
 
  window.addEventListener('load', () => {
    targetElement.classList.add('main');
    checkScroll();  
  });
 
  window.addEventListener('scroll', checkScroll);

  function checkScroll() {
    if (window.scrollY > 30) {
      targetElement.classList.remove('main');
    } else {
      targetElement.classList.add('main');
    }
  }
}